
import React from 'react';
import { IProps } from './types';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Checkbox,
    FormControlLabel,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import style from './style.module.scss';

const NS = 'NewSimpleDialog';

export default function NewSimpleDialog({
    dataTestId,
    isOpen = false,
    confirmText,
    rejectText,
    title,
    description,
    children,
    handleConfirm,
    handleReject,
    dialogSize,
    confirmButtonVariant = 'danger',
    showErrorIcon = true,
    showCheckbox = false,
    checkboxLabel = '',
    checkboxValue = false,
    onCheckboxChange,
    hideCloseButton = false,
    disableBackdropClick = false
}: IProps) {

    return (
        <Dialog
            maxWidth={dialogSize || 'sm'}
            data-testid={dataTestId}
            open={isOpen}
            onClose={disableBackdropClick ? undefined : handleReject}
            disableBackdropClick={disableBackdropClick}
            aria-labelledby="new-simple-dialog-title"
            aria-describedby="new-simple-dialog-description"
            classes={{ paper: style.dialogPaper }}>
            <DialogTitle id="new-simple-dialog-title" disableTypography={true} className={style.dialogTitle}>
                <div className={style.titleContent}>
                    {showErrorIcon && <ErrorIcon className={style.errorIcon} />}
                    <span className={style.titleText}>{title}</span>
                </div>
                {!hideCloseButton && (
                    <IconButton
                        aria-label="close"
                        className={style.closeButton}
                        onClick={handleReject}
                        size="small">
                        <CloseIcon />
                    </IconButton>
                )}
            </DialogTitle>
            <DialogContent className={style.dialogContent}>
                <DialogContentText id="new-simple-dialog-description" className={style.description}>
                    <span dangerouslySetInnerHTML={{ __html: description }} />
                </DialogContentText>
                {showCheckbox && (
                    <div className={style.checkboxContainer}>
                        <FormControlLabel
                            label={checkboxLabel}
                            className={style.checkboxLabel}
                            control={
                                <Checkbox
                                    checked={checkboxValue}
                                    onChange={(e) => onCheckboxChange?.(e.target.checked)}
                                    className={style.checkbox}
                                    style={{
                                        color: checkboxValue ? 'var(--clrNbiMagenta)' : undefined
                                    }}
                                />
                            }
                        />
                    </div>
                )}
            </DialogContent>
            {children}
            <DialogActions className={style.dialogActions}>
                <Button
                    onClick={() => handleReject()}
                    className={style.cancelButton}
                    variant="outlined">
                    {rejectText}
                </Button>
                <Button
                    onClick={() => handleConfirm()}
                    className={confirmButtonVariant === 'primary' ? style.primaryButton : style.deleteButton}
                    variant="contained"
                    autoFocus>
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

